/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EdrDeploymentRegion { 
    /**
     * Description to be shown to user.
     */
    description?: string;
    /**
     * EDR org name if available for this EDR region.
     */
    edr_org_id?: string;
    /**
     * EDR cloud instance region.
     */
    edr_region?: string;
    /**
     * API endpoint
     */
    endpoint?: string;
    /**
     * Internal description.
     */
    internal_description?: string;
    /**
     * Indicates whether the EDR region is enabled.
     */
    is_enabled?: boolean;
    /**
     * Activation status.
     */
    status?: EdrDeploymentRegion.StatusEnum;
}
export namespace EdrDeploymentRegion {
    export type StatusEnum = 'ACTIVATED' | 'NOT_USED';
    export const StatusEnum = {
        ACTIVATED: 'ACTIVATED' as StatusEnum,
        NOT_USED: 'NOT_USED' as StatusEnum
    };
}


